export const format_number_as_currency = number => {
  return `${!!number ? `$${ADV.util.number_format(number, 0)}` : '–'}`;
};

export const getTableSideProps = (
  { expanded_rows },
  { Inflows, Outflows, NetCashflow, People, isPrint },
  { setExpanded },
) => {
  const next = parity => 1 - parity;

  let inflowParity = 0,
    outflowParity = 0;

  const groups = [
    {
      name: 'Inflow',
      even: inflowParity,
      items: Inflows.map(inflow => {
        inflowParity = next(inflowParity);
        return {
          name: inflow.Name,
          expanded: expanded_rows.includes(`Inflow|${inflow.Name}`),
          onClick: setExpanded('Inflow', inflow.Name),
          details: inflow.SubCategories.map(detail => ({
            name: detail.Key,
          })),
          even: inflowParity,
        };
      }),
      footer: 'Total Inflow',
      footerClassName: 'green light-border-top light-border-bottom',
    },
    {
      name: 'Outflow',
      even: false,
      items: Outflows.map(outflow => {
        outflowParity = next(outflowParity);
        return {
          name: outflow.Name,
          expanded: expanded_rows.includes(`Outflow|${outflow.Name}`),
          onClick: setExpanded('Outflow', outflow.Name),
          details: outflow.SubCategories.map(detail => ({
            name: detail.Key,
          })),
          even: outflowParity,
        };
      }),
      footer: 'Total Outflow',
      footerClassName: 'red light-border-top',
    },
    {
      name: 'Net Cash Flow',
      even: false,
      last: true,
      items: [],
    },
  ];
  return {
    groups,
    isPrint: isPrint,
    principalName: People[0].Name,
    hasSpouse: People.length > 1,
    spouseName: People.length > 1 ? People[1]?.Name : '',
  };
};
